import { FormControl, FormLabel, Select } from '@chakra-ui/react'
import { UseFormReturn } from 'react-hook-form'

import { CUSTOM_FORM_KIND_NAME } from 'components/tools/CustomForm/constants'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type QuestionProps = {
  question: CustomFormQuestion
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function KindButton({ formMethods }: QuestionProps) {
  const options = Object.keys(CUSTOM_FORM_KIND_NAME).map((key) => (
    <option key={key} value={key}>
      {CUSTOM_FORM_KIND_NAME[key]}
    </option>
  ))

  return (
    <FormControl display="flex" flexDir="column" gap={2}>
      <FormLabel fontWeight="bold">Tipo de questão</FormLabel>
      <Select {...formMethods.register('kind')}>{options}</Select>
    </FormControl>
  )
}
